import BASE_API from '@/api/dataBase.js';
export const formColumn = (ctx) => {
  return [
    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      type: 'input',
    },
    {
      prop: 'projectInitiationCreateDateStart',
      name: '制单开始日期',
      type: 'startDaterangePicker',
    },
    {
      prop: 'projectInitiationCreateDateEnd',
      name: '制单结束日期',
      type: 'endDaterangePicker',
    },
    {
      prop: 'personNo',
      type: 'searchTableSpec',
      name: '操作人',
      searchType: 'personnel',
      isNeedMultipleValue: false,
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    // {
    //   name: '公司',
    //   prop: 'applyCompanyNo',
    //   options: ctx.companyList1,
    //   type: 'select',
    // },
    // {
    //   prop: 'applyDepartmentNo',
    //   name: '申请部门',
    //   type: 'select',
    //   options: ctx.departmentList,
    //   // clearable: false,
    // },
    {
      prop: 'chargePersonNo',
      type: 'searchTableSpec',
      name: '负责人',
      searchType: 'personnel',
      isNeedMultipleValue: false,
      isMultiple: true,
      changeMethod: 'changeMethod',
      // isNeedMultipleValue: true,
    },
    {
      prop: 'projectNameLike',
      name: '项目名称',
      type: 'input',
      maxlength: 50,
    },

    {
      prop: 'businessType',
      name: '业务类型',
      type: 'dict',
      dictType: 'GoodsTradeProject_businessType',
    },
    {
      // 客户名称
      prop: 'customerNo',
      name: '客户名称',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      extraData: {
        departmentCode: ctx.userInfo.userInfo.departmentCode,
        companyCode: ctx.userInfo.userInfo.companyCode,
      },
      changeMethod: 'changeMethod',
    },

    {
      prop: 'platformtCompanyList',
      name: '平台公司',
      type: 'select',
      options: ctx.companyList1,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'applyDepartmentNo',
      name: '申请部门',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
    },
    // {
    //   prop: 'projectProvinceCode',
    //   name: '所属省份',
    //   type: 'dict',
    //   dictType: 'province',
    // },
    // {
    //   name: '所属地市',
    //   prop: 'projectCityCode',
    //   type: 'ajaxSelect',
    //   apiUrl: BASE_API.QUERY_CITY + '?parentAreaNo=' + ctx.query.projectProvinceCode,
    //   apiData: {},
    // },

    {
      type: 'inputRange',
      prop: ['projectUsageQuotaWanStart', 'projectUsageQuotaWanEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
      name: '使用额度',
      unit: '万元',
    },
    {
      type: 'inputRange',
      prop: ['projectReceivableQuotaWanStart', 'projectReceivableQuotaWanEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
      name: '应收账款额度',
      unit: '万元',
    },

    {
      prop: 'bidStatus',
      name: '招标状态',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'PROJECT_INITIATION_BID_STATUS' },
      type: 'dictSelect',
    },
    {
      prop: 'subjectMatter',
      name: '标的物',
      type: 'dict',
      dictType: 'PROJECT_INITIATION_SUBJECT_MATTER',
      // multiple: true,
    },
    {
      prop: 'projectInitiationStatus',
      name: '项目状态',
      apiData: { dictType: 'PROJECT_INITIATION_STATUS' },
      type: 'dictSelect',
    },
  ];
};

export const columnListDefault = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  // {
  //   type: 'seq',
  //   title: '序号',
  //   visible: true,
  //   width: '80',
  //   fixed: 'left',
  // },
  {
    field: 'projectInitiationCreateDate',
    title: '制单日期',
    visible: true,
  },
  {
    //立项编号
    field: 'projectInitiationNo',
    title: '立项编号',
  },
  {
    field: 'approveDate',
    title: '立项通过时间',
  },
  {
    field: 'businessTypeName', // TODO:
    title: '业务类型',
  },
  {
    field: 'oaUrl',
    title: '审批详情',
  },
  {
    field: 'projectName',
    title: '项目名称',
  },
  {
    field: 'projectInitiationStatus',
    title: '项目状态',
  },
  {
    field: 'projectAddress', // TODO:
    title: '项目地点',
  },
  {
    field: 'subjectMatterName', // TODO:
    title: '标的物',
  },
  {
    field: 'platformtCompanyName',
    title: '平台公司',
  },
  {
    //申请部门
    field: 'departmentName',
    title: '申请部门',
  },
  {
    field: 'supplierName',
    title: '供应商名称',
  },
  {
    field: 'customerName',
    title: '客户名称',
  },
  {
    field: 'chargePersonName',
    title: '负责人',
  },
  {
    field: 'declareDate', // TODO
    title: '申报日期',
  },
  {
    field: 'projectUsageQuota',
    title: '使用额度',
  },
  {
    field: 'projectAccountingPeriod',
    title: '项目账期',
  },
  {
    field: 'projectReceivableQuota',
    title: '应收账款额度',
  },
  // {
  //   field: 'expenseBudget', // TODO
  //   title: '费用预算',
  // },
  // {
  //   field: 'projectIncomePoint',
  //   title: '项目收益点位',
  // },
  {
    field: 'operatingRevenueTarget',
    title: '营业收入目标',
  },
  {
    field: 'profitTarget', // TODO
    title: '利润目标',
  },
  {
    field: 'projectNetProfitRate', // TODO
    title: '项目净利润率',
  },
  {
    field: 'grossProfitRate', // TODO
    title: '毛利率',
  },
  {
    field: 'deliveryQuantity',
    title: '发货数量',
  },
  // {
  //   field: 'advanceAmount', // TODO
  //   title: '垫付金额',
  // },
  // {
  //   field: 'stampDuty', // TODO
  //   title: '印花税',
  // },
  // {
  //   field: 'travelExpense', // TODO
  //   title: '差旅费',
  // },

  // {
  //   field: 'taxRate',
  //   title: '增值税',
  // },
  {
    field: 'costPrediction', // TODO
    title: '成本预计',
  },
  {
    field: 'costOfFunds', // TODO
    title: '资金成本',
  },
  {
    field: 'taxCost', // TODO
    title: '税费成本',
  },
  {
    field: 'sellingExpenses', // TODO
    title: '销售费用',
  },
  {
    field: 'projectMonthlyReturnRate', // TODO
    title: '项目月收益率',
  },
  {
    field: 'effectiveDateOfYield', // TODO
    title: '收益率生效日期',
  },
  {
    field: 'upstreamSettlementAdjustment', // TODO
    title: '上游结算调整',
  },
  {
    field: 'serviceChainRestriction', // TODO
    title: '业务链限制',
  },
  {
    field: 'paymentMethodName', // TODO
    title: '回款方式',
  },
  {
    field: 'validDate',
    title: '授信有效期始',
  },
  {
    field: 'invalidDate',
    title: '授信有效期止',
  },
];
